import './tree_item.scss';
import classnames from 'classnames';
import React, { useRef } from 'react';
import Menu from '~/components/menu';
import useComponentVisible from '~/hooks/useComponentVisible';
import { useTreeView } from './tree_view_provider';
const TreeItem = (props) => {
    const { children, node, label, onNodeSelect, selectedId, onMenuClick, menu, } = props;
    const { icons, expandedItems, toggleExpandedItem, } = useTreeView();
    const nodeId = node.id;
    const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible();
    const targetRef = useRef(null);
    const selectedItemClass = selectedId === nodeId ? 'tree-item-selected' : '';
    const isOpen = node.children && node.children.length > 0 && expandedItems.includes(nodeId);
    const treeItemDisplayClasses = classnames('tree-item-display', {
        indent: !children || '',
        archived: node.isArchived,
    }, selectedItemClass);
    const onMenuClicked = (e) => {
        e.stopPropagation();
        e.preventDefault();
        setIsComponentVisible(!isComponentVisible);
    };
    const onMenuItemClick = (item) => {
        if (onMenuClick) {
            onMenuClick(node, item);
        }
    };
    return (React.createElement("div", { className: "tree-item-row" },
        React.createElement("div", { className: `tree-item-row-container ${selectedItemClass}` },
            React.createElement("span", { className: treeItemDisplayClasses },
                children && (React.createElement("button", { key: `toggle-${nodeId}`, className: "tree-item-toggle", onClick: () => toggleExpandedItem(node) },
                    isOpen && React.createElement("span", null,
                        React.createElement("i", { className: icons.collapseIcon })),
                    !isOpen && React.createElement("span", null,
                        React.createElement("i", { className: icons.expandIcon })))),
                icons.additionalCollapseIcon && icons.additionalExpandIcon && (React.createElement("button", { className: 'tree-item-additional-icon' },
                    isOpen && React.createElement("span", null,
                        React.createElement("i", { className: icons.additionalCollapseIcon })),
                    !isOpen && React.createElement("span", null,
                        React.createElement("i", { className: icons.additionalExpandIcon })))),
                React.createElement("button", { className: "tree-item-name", onClick: () => onNodeSelect(node), title: node.name }, label),
                menu && menu.length > 0 && (React.createElement("span", { className: "tree-item-menu-button", ref: targetRef },
                    React.createElement("button", { onClick: (e) => onMenuClicked(e) },
                        React.createElement("i", { className: "far fa-ellipsis-v" })),
                    React.createElement(Menu, { ref: ref, targetRef: targetRef.current, showMenu: isComponentVisible, setShowMenu: setIsComponentVisible, onMenuItemClick: onMenuItemClick, menuItems: menu }))))),
        isOpen && (React.createElement("div", { className: "tree-item-indent" }, children))));
};
export default TreeItem;
